import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "./Icon";

const TABS = [
  { id: "home", label: "HOME", icon: "menu", to: "/" },
  { id: "shop", label: "SHOP", icon: "grid", to: "/shop" },
  { id: "sale", label: "SALE", icon: "tag", to: "/shop?tags=SALE" },
  { id: "mypage", label: "ME", icon: "user", to: "/mypage" },
  { id: "cart", label: "CART", icon: "bag", to: "/cart" },
];

export default function MobileTabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div
      style={{
        position: "sticky",
        bottom: 0,
        zIndex: 20,
        background: "var(--paper)",
        borderTop: "1px solid var(--hair)",
        display: "grid",
        gridTemplateColumns: "repeat(5,1fr)",
        padding: "8px 4px 12px",
      }}
    >
      {TABS.map((t) => {
        const on = location.pathname === t.to.split("?")[0];
        return (
          <button
            key={t.id}
            onClick={() => navigate(t.to)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
              padding: "6px 0",
              fontSize: 9,
              fontFamily: "var(--f-mono)",
              letterSpacing: "0.1em",
              color: on ? "var(--ink)" : "var(--ink-mute)",
              fontWeight: 600,
            }}
          >
            <Icon name={t.icon} size={20} stroke={on ? 2 : 1.6} />
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
